import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DashboardService } from '../../services/dashboard.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { Subject } from 'rxjs';

declare var TimeMe;
var inactivatetime = 0;
var intervalID;

@Component({
  selector: 'app-hiration',
  templateUrl: './hiration.component.html',
  styleUrls: ['./hiration.component.css']
})
export class HirationComponent implements OnInit, AfterViewInit {
  url = '';
  progDashboardId;
  currProgId;
  hirationHTML: SafeHtml;
  @ViewChild('iframe') iframe: ElementRef;
  userActivity;
  userInactive: Subject<any> = new Subject();
  timeTrackingObj ={};

  constructor(private route: ActivatedRoute, private dashboardService: DashboardService, private _sanitizer: DomSanitizer,
    private commonService: CommonService) {
      this.setTimeout();
      this.userInactive.subscribe(() =>{
        // console.log('user has been inactive for 15min');
      });
    }

  ngOnInit(): void {
    
    this.currProgId = this.route.snapshot.params['pid'];
    this.progDashboardId = this.route.snapshot.params['pdid'];
    TimeMe.initialize({
	    currentPageName: "dashboardPage", // current page
    });
    TimeMe.startTimer();
    if(this.currProgId && this.progDashboardId) {
      // this.url = `https://dev-ipj-api.harappa.education/api/v1/ipj/user-progress/hiration/start?programActivationId=${this.currProgId}&programDashboardId=${this.progDashboardId}&activationDashboardType=INTEGRATION`;
      this.getHirationHTML(this.currProgId, this.progDashboardId)
    }
    this.timeTrackingObj['eventType'] = "PROG-INTEGRATION";
    this.timeTrackingObj['programDashboardId'] = this.progDashboardId;
    this.timeTrackingObj['programActivationId'] = this.currProgId;
    this.timeTrackingObj['organization'] = this.route.snapshot.params['org'];
  }

  getHirationHTML(pid, pdid) {
    this.dashboardService.getHirationHTML(pid, pdid).subscribe(res => {
      if(res && res['data']) {
        // this.hirationHTML = this._sanitizer.bypassSecurityTrustHtml(res['data']);
        this.iframe.nativeElement.contentWindow.document.write(res['data']);
      }
    }) 
  }

  timeLeaveTab = TimeMe.callWhenUserLeaves(function(){
    TimeMe.resetAllRecordedPageTimes();
    TimeMe.stopTimer();
  },1000);

  timeOnreturnTab = TimeMe.callWhenUserReturns(function(){
    TimeMe.initialize();
    TimeMe.startTimer(); 
  });

  setTimeout() {
    clearInterval(intervalID);
    inactivatetime = 0;
    this.userActivity = setTimeout(
      () => {
        this.userInactive.next(undefined);
        this.setTimetrackingOnReportpage(TimeMe.getTimeOnCurrentPageInSeconds());
        TimeMe.resetAllRecordedPageTimes();
        TimeMe.initialize();
        TimeMe.startTimer(); 

        intervalID = setInterval(()=>{
          inactivatetime= inactivatetime+1;
          if(inactivatetime >= 900){
            clearInterval(intervalID);
            TimeMe.resetAllRecordedPageTimes();
            TimeMe.initialize();
          }
        }, 1000);
      },
      1000*60*2
    );
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearInterval(intervalID);
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  @HostListener('window:blur', ['$event'])
   onBlur(event: FocusEvent): void { 
    this.setTimetrackingOnReportpage(TimeMe.getTimeOnCurrentPageInSeconds());
    TimeMe.resetAllRecordedPageTimes();
    TimeMe.stopTimer();
  }

  setTimetrackingOnReportpage(calcTime){
    if(calcTime > 0){
      this.timeTrackingObj['spentTime'] = calcTime;
      this.commonService.saveTimespentonPages(this.timeTrackingObj).subscribe(resp => {})
    }
  }

  ngOnDestroy() {
    this.setTimetrackingOnReportpage(TimeMe.getTimeOnCurrentPageInSeconds())
  }

  ngAfterViewInit() {
  }
}
